<mat-toolbar class="hide-print header" *ngIf="!clientMode">
  <div
    class="back"
    (click)="goBack()"
    matTooltip="Atrás"
    matTooltipPosition="right"
  >
    <mat-icon >arrow_back_ios_new</mat-icon>
  </div>
  <div>
    <span class="hide-mobile">Presupuesto de Trabajo&nbsp;</span>Nº {{budget?.correlative_id}}
  </div>

  <div class="expander"></div>

  <i class="fa fa-spin fa-spinner" *ngIf="saving"></i>
  <i class="fa fa-check" *ngIf="!saving && saved" matTooltip="Guardado"></i>
  <i
    class="fa fa-save"
    *ngIf="!saving && !saved && (roleService.can('update','budget') | async) && !budget.status.locked"
    matTooltip="Guardar"
    (click)="saveBudget(true)"
    tabindex
  >
  </i>

  <button mat-button [mat-menu-trigger-for]="menu"><mat-icon>more_horiz</mat-icon></button>
  <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="print('inline')"><mat-icon>open_in_new</mat-icon> Abrir en nueva pestaña</button>
    <button mat-menu-item (click)="print()"><mat-icon>download</mat-icon> Descargar</button>
    @if (budget && budget.items.length > 0) {
      <button mat-menu-item (click)="remigrate()"><mat-icon>replay</mat-icon> Restaurar</button>
    }
    <button
      mat-menu-item
      [appOpenInModal]="ownersList"
      modalTitle="Lista de Miembros"
      [modalConfig]="{ minWidth: '80%' }"
      [modalFooterButtons]="[]"
      >
      <mat-icon>group</mat-icon> Ver Miembros
      <ng-template #ownersList>
        <app-document-owners-list [documentId]="budget.id" documentType="Budget">
        </app-document-owners-list>
      </ng-template>
    </button>
    <button mat-menu-item (click)="addChat()" *ngIf="(roleService.can('update','check_in') | async)"><mat-icon>chat</mat-icon> Agregar al Chat</button>
  </mat-menu>

</mat-toolbar>

<div class="wrapper" #wrapper>
  @if (!budget) {
    <div class="skeleton-container" >
      <div class="skeleton" style="height: 98px;"></div>
      <div class="skeleton" style="height: 123px;"></div>
      <div class="skeleton" style="height: 170px;"></div>
      <div class="skeleton" style="height:  74px;"></div>
      <div class="skeleton" style="height:  90px;"></div>
    </div>
  }

  <div class="order" *ngIf="budget">
    <div class="content">
      <mat-accordion multi>
        <mat-expansion-panel disabled class="expansion-title">
          <mat-expansion-panel-header>
              <div class="panel-title">
                General
              </div>
          </mat-expansion-panel-header>
        </mat-expansion-panel>
        <mat-expansion-panel>
            <mat-expansion-panel-header>
              <div class="panel-title">
                <mat-icon>engineering</mat-icon>
                {{budget?.order?.location?.name}} - {{budget.user?.name || 'Sin solicitante'}}
              </div>
            </mat-expansion-panel-header>
            <div class="info">
              <div class="name">Solicitante</div><div class="value">{{budget.user?.name}}</div>
              <div class="name">Creación</div><div class="value">{{budget.created_at | date:'shortDate'}}</div>
            </div>
        </mat-expansion-panel>

        <mat-expansion-panel>
            <mat-expansion-panel-header>
              <div class="panel-title">
                <mat-icon>description</mat-icon>
                Orden Nº {{budget.order.correlative_id}}
                <div class="expander"></div>
                <div class="order-button hide-mobile" (click)="goOrder()">Ver Orden</div>
              </div>
            </mat-expansion-panel-header>
            <div class="info">
              <div class="name">Requerimiento</div><div class="value">{{budget.order.requirement?.name}}</div>
              <div class="name hide-print">Comentario</div><div class="value hide-print">{{budget.order.comment}}</div>  
            </div>
            <br>
            <div class="order-button hide-desktop" (click)="goOrder()">Ver Orden</div>
        </mat-expansion-panel>

        <mat-expansion-panel>
            <mat-expansion-panel-header>
              <div class="panel-title">
                <mat-icon>person</mat-icon>
                {{(budget?.order?.client?.name | titlecase) || ('client' | human)}}
                <i class="hide-mobile panel-subtitle">{{budget?.order?.client?.rut | identifier }}</i>
                <span class="hide-mobile"><app-stars [stars]="budget.client?.rating"></app-stars></span>
                <div class="expander"></div>
                <div class="order-button hide-mobile" go-to-details [element]="{ id: budget?.order?.client?.id, type: 'Client'}">
                  <span>Ver {{adminService.getText('client')}}</span>
                </div>
              </div>
            </mat-expansion-panel-header>
            <div class="info">
              <div class="name">Nombre</div><div class="value">{{budget.order.client?.name || 'No existe el cliente'}}</div>
              <div class="name">Teléfono</div><div class="value"><a href="tel:{{budget.order.client?.phone}}" class="phone"><i class="fa fa-phone"></i>{{budget.order.client?.phone}}</a></div>
              <div class="name">Categoría</div>
              <div class="value"><app-stars [stars]="budget.client?.rating"></app-stars></div>
            </div>
        </mat-expansion-panel>

        @if (budget.order.vehicle) {
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <div class="panel-title">
                <mat-icon>directions_car</mat-icon>
                  {{ budget.order?.object?.brand?.name + ' ' + budget.order?.object?.brand_model?.name | truncate: ["20"]}} <i  class="panel-subtitle hide-mobile">#{{budget.order?.object?.identifier || budget.order?.object_id}}</i>
                  <div class="expander hide-mobile"></div>
                  <div class="order-button hide-mobile" go-to-details [element]="{ id: budget.order?.object?.id, type: 'Vehicle'}">
                    <span>Ver {{adminService.getText('object')}}</span>
                  </div>
              </div>
            </mat-expansion-panel-header>

            <div class="info">
              <div class="name">Patente</div>
              <div class="value">{{budget.order.vehicle?.identifier}}</div>

              <div class="name hide-print">Marca</div>
              <div class="value hide-print">{{budget.order.vehicle?.brand?.name}}</div>

              <div class="name hide-print">Modelo</div>
              <div class="value hide-print">{{budget.order.vehicle?.brand_model?.name}}</div>

              <div class="name">Chasis</div>
              <div class="value">{{budget.order.vehicle?.chasis || '-'}}</div>
              @if (budget.order.kms >= 0) {
                <div class="name hide-print">Kilometraje</div>
                <div class="value hide-print" hide-print>{{budget.order.kms || budget.order.vehicle?.kms}}</div>
              }
              <div class="name hide-print">Color</div>
              <div class="value hide-print">{{budget.order.vehicle?.color}}</div>
            </div>
            <br>
            <div class="order-button hide-desktop" go-to-details [element]="{ id: budget.order?.object?.id, type: 'Vehicle'}">
              <span>Ver {{adminService.getText('object')}}</span>
            </div>
          </mat-expansion-panel>
        }
      </mat-accordion>

      <br />

      @if(!this.budget?.status?.locked || budget.pictures?.length > 0){
      <div class="subtitle">Imagenes adjuntas al Presupuesto</div>
      <div class="images-container">
        <app-image-uploader
          [gallery]="picturesInGallery"
          [photos]="budget.pictures"
          (uploaded)="setImages($event)"
          [scrollTarget]="wrapper"
          [small]="true"
          [readonly]="((roleService.can('update','budget') | async) === false) || budget.status.locked"
        >
        </app-image-uploader>
      </div>
     }

      <div class="subtitle">Servicios</div>
      <div class="items" #inputs>

        <div class="items-empty" [hidden]="inventory_actions_form.controls.length !== 0">
          No hay items. Por favor agregue marcadores para empezar
        </div>
        <ng-container>

        @if (!(adminService.local$.getValue().preferences.budget_type === 'simple')){
          <div class="expanded-views-container">
            @for (formGroup of inventory_actions_form.controls; track formGroup.getRawValue().id) {
              <div class="expanded-view" [ngClass]="{'focused': focusedItem() === $index}" (click)="focusedItem.set($index)">
                <div class="expanded-view__header">
                    <div class="tag_circle" [style.background-color]="getTag(formGroup.get('tag_id')?.value)?.color"></div>
                    <span class="header_text"> {{getTag(formGroup.get('tag_id')?.value)?.name}}</span>

                    @if (!budget.status.locked && !formGroup.getRawValue().status.locked) {
                      <div class="expander"></div>
                      <button mat-icon-button matSuffix (click)="removeItem($index)" matTooltip="Remover">
                        <mat-icon color="warn">delete</mat-icon>
                      </button>

                    }
                </div>
                @if((formGroup.get('pictures')?.value?.length > 0) || !budget.status.locked ){
                  <span class="photo-subtitle">Fotos adjuntas</span>
                  <app-image-uploader
                    [gallery]="budget.order.order_attachments.concat(budget.pictures)"
                    [photos]="formGroup.get('pictures')?.value"
                    (uploaded)="setImagesToInventoryAction(formGroup, $index, $event)"
                    [scrollTarget]="wrapper"
                    [small]="true"
                    [readonly]="((roleService.can('update','budget') | async) === false)"
                    [allowUploadPhoto]="false"
                    [allowUploadFile]="false"
                    [allowAdvanceUpload]="false"
                    [readonly]="((roleService.can('update','budget') | async) === false) || budget.status.locked"
                    >
                  </app-image-uploader>

                }

                <app-inventory-action-form
                  [parentFormGroup]="(formGroup | formGroup)"
                  [filterCategories]="getTagCategories(formGroup.getRawValue().tag_id)"
                  (dataChanged)="updateInventoryAction($index)"
                  [showTotals]="false"
                  (approved)="saveBudget(true)"
                  (declined)="saveBudget(true)"
                  [simpleView]="adminService.local$.getValue().preferences.budget_type === 'simple'"
                  [brandId]="budget.order.object?.brand?.id"
                  [focused]="focusedItem() === $index"
                  [requirementId]="budget.order.requirement_id"
                  [checkForDiscounts]="true"
                  [enableDiscounts]="true"
                  parentModel="budget"
                >
                </app-inventory-action-form>
              </div>
            }
            @if(!budget.status.locked
              && (roleService.can('update','budget') | async)){
              <div class="expanded-view">
                <div class="add-marker" >
                  <button class="add-button" *ngFor="let tag of tags; let index = index" [class.saving]="saving"
                      mat-button
                      (click)="createInventoryAction(tag)"
                      [disabled]="saving"
                      [style.background-color]="tag?.color"
                      [style.color]="'white'"
                  >
                    <i class="fas fa-plus"></i> {{tag.name}}
                  </button>
                </div>
              </div>

            }
          </div>
        }
        @else{
          @for (formGroup of inventory_actions_form.controls; track formGroup.getRawValue().id) {
            <div class="simple-view-container">
              <div class="tag-container">
                <div class="tag_bar" [style.background-color]="getTag(formGroup.get('tag_id')?.value)?.color"></div>
              </div>
              <div class="inventory-container">
                <app-inventory-action-form
                    [parentFormGroup]="(formGroup | formGroup)"
                    [filterCategories]="getTagCategories(formGroup.getRawValue().tag_id)"
                    (dataChanged)="updateInventoryAction($index)"
                    [showTotals]="false"
                    (approved)="saveBudget(true)"
                    (declined)="saveBudget(true)"
                    [simpleView]="adminService.local$.getValue().preferences.budget_type === 'simple'"
                    [brandId]="budget.order.object?.brand?.id"
                    parentModel="budget"
                    [gallery]="budget.order.order_attachments.concat(budget.pictures)"
                    [photos]="formGroup.get('pictures')?.value"
                    [isReadOnly]="((roleService.can('update','budget') | async) === false) || budget.status.locked"
                  >
                  </app-inventory-action-form>
              </div>
              @if (!budget.status.locked && !formGroup.getRawValue().status.locked) {
                <button mat-mini-fab class="delete-button" (click)="removeItem($index)" matTooltip="Remover" matTooltipPosition="left"><mat-icon>delete</mat-icon></button>
              }

              @if (!budget.status.locked){
              <button mat-mini-fab class="duplicate-button" (click)="duplicateInventoryAction($index)"  matTooltip="Duplicar" matTooltipPosition="left" [disabled]="working">
                @if (!working){
                  <mat-icon>content_copy</mat-icon>
                }
                @else {
                  <mat-icon>hourglass_empty</mat-icon>
                }
              </button>
              }
            </div>
          }
          @if(!budget.status.locked && (roleService.can('update','budget') | async)){
            <div class="simple-view-container">
              <div class="add-marker" >
                <button class="add-button" *ngFor="let tag of tags; let index = index" [class.saving]="saving"
                    mat-button
                    (click)="createInventoryAction(tag)"
                    [disabled]="saving"
                    [style.background-color]="tag?.color"
                    [style.color]="'white'"
                >
                  <i class="fas fa-plus"></i> {{tag.name}}
                </button>
              </div>
            </div>

          }
        }



        </ng-container>
      </div>
      <div class="subtitle">Totales</div>
      <div class="totals">
        @for(category of categories; track category.id) {
          @if (totals[category.id] !== undefined){
            <div class="total">{{category.name}}: {{totals[category.id] | money}}</div>
          }
        }
        <div class="total" [ngClass]="{'discount': discountTotal > 0}">Neto: {{budget.total + discountTotal| money}}</div>
        <div class="total" *ngIf="discountTotal > 0">Descuentos: -{{ discountTotal | money }}</div>
        <div class="total discount__label" *ngIf="discountTotal > 0">Neto: {{budget.total| money}}</div>

        <div class="total">{{adminService.getText('tax','uppercase','IVA')}}: {{budget.total*(country.preferences.tax_rate - 1) | money}}</div>
        <div class="total">Total: {{budget.total*(country.preferences.tax_rate) | money}}</div>
      </div>

    </div>
    <div class="content hide-print" *ngIf="!clientMode">

      <app-order-fields
        [parentFormGroup]="budgetForm"
        [readonly]="clientMode || budget.status.locked"
        [reactiveFormMode]="true"
        [model]="budget"
        mode="Budget"
      ></app-order-fields>

      <mat-accordion multi>

        <mat-expansion-panel class="expansion-panel">
          <mat-expansion-panel-header>
              <div class="panel-title">
                <mat-icon>request_quote</mat-icon>
                {{ 'inventory_action/pricing' | human: null: null: 'plural' | titlecase }} &nbsp; <span>({{budget?.pricings?.length || 0}})</span>
              </div>
          </mat-expansion-panel-header>
          <mat-accordion multi >
            @for (pricing of budget.pricings; track pricing.id) {
              <mat-expansion-panel class="expansion-panel">
                <mat-expansion-panel-header>
                    <div class="panel-title">
                      <mat-icon>request_quote</mat-icon>
                      {{ 'inventory_action/pricing' | human | titlecase }} #<span>{{pricing.correlative_id}}</span>
                    </div>
                </mat-expansion-panel-header>

                <div class="info">
                  <div class="name">Proveedor:</div><div class="value">{{ pricing.owner.name }}</div>
                  <div class="name">Estado:</div><div class="value">{{ pricing.status?.name }}</div>
                  <div class="name">Respondida:</div><div class="value">{{ pricing.draft ? 'No' : 'Si' }}</div>
                </div>
                <br />

                
                <div class="info">
                  @for(item of pricing.extra_params.required_products; track item.product_id) {
                    @if (item.quantity != 0){
                      <div class="quantity right">{{item.quantity}}</div>
                      <div class="value inline">{{item.product?.code}} - {{item.product?.name}}</div>
                    }
                  }
                </div>

                <div class="budget-buttons">
                  <button
                    mat-button
                    class="primary"
                    go-to-details
                    [element]="pricing"
                  >Ver {{ 'inventory_action/pricing' | human | titlecase }}</button>
                </div>
              </mat-expansion-panel>
            }
          </mat-accordion>
        </mat-expansion-panel>

        <mat-expansion-panel class="expansion-panel">
          <mat-expansion-panel-header>
              <div class="panel-title">
                <mat-icon>list_alt</mat-icon>
                {{ 'inventory_action/buy_order' | human: null: null: 'plural' | titlecase }} &nbsp; <span>({{budget?.buy_orders?.length || 0}})</span>
              </div>
          </mat-expansion-panel-header>
          <mat-accordion multi >
            @for (buy_order of budget.buy_orders; track buy_order.id) {
              <mat-expansion-panel class="expansion-panel">
                <mat-expansion-panel-header>
                    <div class="panel-title">
                      <mat-icon>list_alt</mat-icon>
                      {{ 'inventory_action/buy_order' | human | titlecase }} Nº <span>{{buy_order.correlative_id}}</span>
                    </div>
                </mat-expansion-panel-header>

                <div class="info">
                  <div class="name">Proveedor:</div><div class="value">{{ buy_order.owner.name }}</div>
                  <div class="name">Estado:</div><div class="value">{{ buy_order.status?.name }}</div>
                  <div class="name">Respondida:</div><div class="value">{{ buy_order.draft ? 'No' : 'Si' }}</div>
                </div>
                <br />


                <div class="info">
                  @for(item of buy_order.inventory_action_products; track item.product_id) {
                    @if (item.quantity != 0){
                      <div class="quantity right">{{item.quantity}}</div>
                      <div class="value inline">{{item.product?.code}} - {{item.product?.name}}</div>
                    }
                  }
                </div>

                <div class="budget-buttons">
                  <button
                    mat-button
                    class="primary"
                    go-to-details
                    [element]="buy_order"
                  >Ver {{ 'inventory_action/buy_order' | human | titlecase }}</button>
                </div>
              </mat-expansion-panel>
            }
          </mat-accordion>
        </mat-expansion-panel>

        <mat-expansion-panel class="expansion-panel">
          <mat-expansion-panel-header>
              <div class="panel-title">
                <mat-icon>request_quote</mat-icon>
                {{ 'invoicing' | human | titlecase }} &nbsp; <span>({{budget?.invoices?.length || 0}})</span>
              </div>
          </mat-expansion-panel-header>
          <mat-accordion multi >
            @for (invoice of budget.invoices; track invoice.id) {
              <mat-expansion-panel class="expansion-panel">
                <mat-expansion-panel-header>
                    <div class="panel-title">
                      <mat-icon>request_quote</mat-icon>
                      {{ invoice.invoice_type | human | titlecase }} #<span>{{invoice.correlative_id}}</span>
                    </div>
                </mat-expansion-panel-header>

                <div class="info">
                  <div class="name">{{ invoice.stakeholder_type | human }}:</div><div class="value">{{ invoice.stakeholder.name }}</div>
                  <div class="name">Fecha Emision:</div><div class="value">{{ invoice.created_at | date }}</div>
                  <div class="name">Fecha de Pago:</div><div class="value">{{ invoice.due_date | date }}</div>
                  <div class="name">Método de Pago:</div><div class="value">{{ invoice.data?.payment?.payment_method | human }}</div>
                  <div class="name">Monto Pagado:</div><div class="value">{{ invoice.data?.payment?.amount | money }}</div>
                </div>

                <br />

                <div class="info">
                  @for(item of invoice.data.details; track item.product_id) {
                    @if (item.quantity != 0){
                      <div class="quantity right">{{item.quantity}}</div>
                      <div class="value inline">{{item.product?.code}} - {{item.product?.name}}</div>
                    }
                  }
                </div>

                <div class="budget-buttons">
                  @if (invoice.url) {
                    <a
                      mat-button
                      href="{{ invoice.url }}"
                      target="_blank"
                      class="primary"
                    >Ver {{ invoice.invoice_type | human | titlecase }}</a>
                  } @else {
                    <button
                      mat-button
                      class="primary"
                      go-to-details
                      [element]="invoice"
                    >Ver {{ invoice.invoice_type | human | titlecase }}</button>
                  }
                </div>
              </mat-expansion-panel>
            }
          </mat-accordion>
        </mat-expansion-panel>

        <mat-expansion-panel class="budget-expansion-panel-works expansion-panel">
          <mat-expansion-panel-header>
              <div class="panel-title">
                <mat-icon>build_circle</mat-icon>
                Trabajos&nbsp;<span>({{budget.works?.length}})</span>
              </div>
          </mat-expansion-panel-header>
          <app-document-works [order]="budget" (load)="load()"></app-document-works>
        </mat-expansion-panel>

        <mat-expansion-panel class="expansion-panel" *ngIf="budget && budget.comments">
          <mat-expansion-panel-header>
              <div class="panel-title">
                <mat-icon>forum</mat-icon>
                Bitácora&nbsp;<span>({{budget.comments?.length || 0}})</span>
              </div>
          </mat-expansion-panel-header>
          <app-order-comments [comments]="budget.comments" (saveComment)="saveComment($event)"></app-order-comments>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>

</div>
<mat-toolbar class="hide-print footer" *ngIf="!clientMode && budget">
  <div class="buttons hide-print">
    <app-work-request-button
      [id]="budget.id"
      [document]="budget"
      type="Budget"
      [status_id]="budget.status_id"
      [allowedDocumentsForCreation]="allowedDocumentsForCreation()"
      (afterDialogClose)="load()"
    >
    </app-work-request-button>
    <button 
        mat-raised-button class="primary"
        [matMenuTriggerFor]="menu"
        *ngIf="(roleService.can('update','budget') | async)"
        [disabled]="working"
        >
      @if (working){
        <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
      } @else {
        <i class="fa fa-pencil-alt"></i>
      }
      <span class="hide-mobile">{{budget.status.name}}</span>
    </button>
    <mat-menu #menu="matMenu">
      @for (status of statuses; track status.id) {
        <button
          mat-menu-item
          (click)="setStatus(status.id)"
          [style.color]="status.color"
          [disabled]="working || status.id === budget.status_id"
          matTooltip="Estado actual"
          [matTooltipDisabled]="status.id !== budget.status_id"
          matTooltipPosition="right"
        >
          <span>{{status.name}}</span>
          @if (status.id === budget.status_id) {
            &nbsp;
            <div class="fa fa-check"></div>
          }
        </button>
      }
    </mat-menu>
  </div>
  <div class="expander"></div>
  @if(this.budget?.status?.approval && pendingForApproval() > 0){
    <button type="button" mat-button class="reject hide-mobile" (click)="declineAll()" [disabled]="working"><span>Rechazar Todos</span></button>
    <button type="button" mat-button class="approval hide-mobile" (click)="approveAll()" [disabled]="working"><span>Aprobar Todos</span></button>
  }
  <span class="footer-total">Total: {{budget.total*(country.preferences.tax_rate) | money}}</span>
</mat-toolbar>
